<script setup lang="ts">
import { i18n } from '@apps/main/modules/localization/localizationSetup';

import { AppSvgIcon, SemboGuaranteeIcon } from '@libs/ui';

interface PriceGuaranteeBannerEmits {
  (eventName: 'learn-more'): void;
}
const emit = defineEmits<PriceGuaranteeBannerEmits>();

const { t } = i18n.global;
</script>

<template>
  <button class="price-guarantee-banner" @click.stop="emit('learn-more')">
    <div class="left-column">
      <SemboGuaranteeIcon />
    </div>
    <div class="right-column">
      <div class="price-guarantee-banner-title">
        {{ t('price_guarantee.banner.title') }}
      </div>
      <AppSvgIcon name="infoCircle" size="18" />
    </div>
  </button>
</template>

<style scoped lang="scss">
.price-guarantee-banner {
  display: flex;
  gap: var(--spacing-12);
  padding: var(--spacing-8);
  width: 100%;
  text-align: left;
  color: var(--color-neutral-70);

  @include on-hover {
    cursor: pointer;
    background: var(--color-neutral-10);
    border-radius: var(--border-radius-12);
    transition: background var(--transition-short);
  }

  .left-column {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .right-column {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex: 1;
    gap: var(--spacing-8);

    .price-guarantee-banner-title {
      @include font-label-m-bold;
    }
  }
}
</style>
